import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Loader } from '@corecomponents/ui'
import PrivateRoutes from '@config/PrivateRoute'
import CohortSelection from '@container/CohortSelection'
import OrderSummary from '@container/Sales/order-summary'
import CSCLandingPage from '@container/Csc/CSCLandingPage/CSCLandingPage'
import CSCAuthorize from '@container/Csc/authroize'
import CSCDashboard from '@container/Csc/dashboard'

const AmbassdorLanding = React.lazy(
  () => import('@container/AmbassadorLanding')
)

const Contact = React.lazy(() => import('@container/Contact'))
const Certificate = React.lazy(() => import('@container/Certificate'))
const Leads = React.lazy(() => import('@container/LeadManagement'))
const Earning = React.lazy(() => import('@container/EarningLevel'))
const Payment = React.lazy(() => import('@container/Payment'))
const Profile = React.lazy(() => import('@container/Profile'))
const Resource = React.lazy(() => import('@container/Resource'))
const ResourceDetails = React.lazy(() => import('@container/ResourceDetails'))
const AmbassdorDashboard = React.lazy(
  () => import('@container/AmbassadorDashboard')
)
const PerformanceReport = React.lazy(
  () => import('@container/PerformanceReport')
)
const AmbassdorRegistration = React.lazy(
  () => import('@container/AmbassdorRegistration')
)
const BatchListing = React.lazy(() => import('@container/Sales/batch-listing'))
const AfterPayment = React.lazy(() => import('@container/Sales/after-payment'))
const Register = React.lazy(() => import('@container/Register'))

const SignUpSpecialLink = React.lazy(
  () => import('@container/SignUpSpecialLink')
)
const AppDetailsForSignUp = React.lazy(
  () => import('@container/AppDetailsForSignUp')
)

type AmbassadorRoutesProps = object

const AmbassdorRoutes: React.FC<AmbassadorRoutesProps> = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<AmbassdorLanding />}></Route>;
        <Route path="/csc" element={<CSCLandingPage />}></Route>;
        <Route path="/csc/authorize" element={<CSCAuthorize />}></Route>;
        <Route path="/csc/dashboard" element={<CSCDashboard />}></Route>;
        <Route path="/sales/order-summary" element={<OrderSummary />}></Route>;
        <Route path="/register" element={<Register />}></Route>;
        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<AmbassdorDashboard />}></Route>
          <Route
            path="/registration/:stage"
            element={<AmbassdorRegistration />}
          ></Route>
          <Route path="/dashboard/contact" element={<Contact />}></Route>;
          <Route
            path="/dashboard/certificate"
            element={<Certificate />}
          ></Route>
          <Route path="/dashboard/resource" element={<Resource />}></Route>;
          <Route path="/dashboard/earn" element={<Earning />}></Route>;
          <Route path="/dashboard/leads" element={<Leads />}></Route>;
          <Route
            path="/dashboard/performance"
            element={<PerformanceReport />}
          ></Route>
          <Route
            path="/dashboard/payment"
            element={<PerformanceReport />}
          ></Route>
          <Route
            path="/dashboard/resource/:id"
            element={<ResourceDetails />}
          ></Route>
          <Route path="/dashboard/profile" element={<Profile />}></Route>
          <Route
            path="/dashboard/special-link"
            element={<SignUpSpecialLink />}
          ></Route>
          <Route
            path="/dashboard/special-link/details"
            element={<AppDetailsForSignUp />}
          ></Route>
          <Route path="/sales/batch-listing" element={<BatchListing />}></Route>
          ;
          <Route path="/sales/after-payment" element={<AfterPayment />}></Route>
          ;
          {/* <Route path="/sales/order-summary" element={<OrderSummary />}></Route>; */}
          <Route path="/cohort-selection" element={<CohortSelection />}></Route>
          ;
        </Route>
      </Routes>
    </Suspense>
  )
}

export default AmbassdorRoutes
